<template>
  <div>
    <b-row align-h="center">
      <h2 class="product__title">Details</h2>
      <b-table striped hover :items="product"></b-table>
    </b-row>

    <b-row align-h="center">
      <h2 class="product__title">Parts used</h2>
      <b-table striped hover :items="parts"></b-table>
    </b-row>

    <b-row align-h="center" class="my-4" v-if="isOwner">
      <h2 class="product__title">Transfer Ownership</h2>
      <b-col lg="12" class="root">
        <b-row
          ><b-col lg="10"
            ><label class="sr-only" for="inline-form-input-username"
              >Address</label
            >
            <b-input-group prepend="Address" class="mb-2 mr-sm-2 mb-sm-0">
              <b-input
                id="inline-form-input-username"
                placeholder="Enter address ..."
                v-model="address"
              ></b-input> </b-input-group
          ></b-col>

          <b-col lg="2"
            ><b-button
              block
              variant="primary"
              @click="submit"
              :disabled="isProcessing"
              >Submit</b-button
            ></b-col
          >
        </b-row></b-col
      >
    </b-row>

    <product-history :id="Number($route.params.id)" />

    <Decode
      :isVisible="isVisible"
      @clicked="child_passphrase"
      @redirect="child_redirect"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { signAndSendTransaction } from '@/ethereum/send'
import Decode from '@/components/modal/Decode.vue'
import CryptoJS from 'crypto-js'
import ProductHistory from '../components/product/History.vue'
import web3 from 'web3'
export default {
  components: {
    ProductHistory,
    Decode
  },
  computed: {
    ...mapState(['contracts', 'accounts']),
    isOwner: function() {
      const { product, accounts } = this

      if (product.length === 0) return false

      return product[0].productOwner === web3.utils.toChecksumAddress(accounts)
    }
  },
  async mounted() {
    const { contracts, accounts } = this

    let result = await contracts.Implementation.methods
      .getProductDetails(this.$route.params.id)
      .call({ from: accounts })

    if (!result) return

    const dat = new Date(result[5] * 1000)

    let formatted_date =
      dat.getMonth() +
      1 +
      '-' +
      dat.getDate() +
      '-' +
      dat.getFullYear() +
      ' ' +
      dat.getHours() +
      ':' +
      dat.getMinutes() +
      ':' +
      dat.getSeconds()

    this.product.push({
      id: this.$route.params.id,
      productOwner: result[4],
      modelNumber: result[0],
      partNumber: result[1],
      serialNumber: result[2],
      Date: formatted_date
    })

    result[6].forEach(async index => {
      let item = await contracts.Implementation.methods
        .getPartDetails(index)
        .call({ from: accounts })

      const dat = new Date(item[3] * 1000)

      let formatted_date =
        dat.getMonth() +
        1 +
        '-' +
        dat.getDate() +
        '-' +
        dat.getFullYear() +
        ' ' +
        dat.getHours() +
        ':' +
        dat.getMinutes() +
        ':' +
        dat.getSeconds()

      this.parts.push({
        partNumber: item[0],
        serialNumber: item[1],
        cost: item[2],
        supplierAddress: item[6],
        date: formatted_date
      })
    })

    console.log('Product Array : ', this.product)
    // await contracts.
  },
  data() {
    return {
      product: [],
      parts: [],
      address: '',
      isProcessing: false,
      passphrase: '',
      isVisible: false
    }
  },

  methods: {
    submit: async function() {
      const { contracts, address, accounts, passphrase } = this

      if (!passphrase) {
        this.isVisible = true
        return
      }

      this.isProcessing = !this.isProcessing

      let result = await contracts.Implementation.methods.transferToOwner(
        accounts,
        address,
        this.$route.params.id
      )

      let decrypted = CryptoJS.AES.decrypt(
        sessionStorage.getItem('private_key'),
        this.passphrase
      )

      const acc = decrypted.toString(CryptoJS.enc.Utf8)
      const response = await signAndSendTransaction(result, acc)

      if (response) {
        this.isProcessing = !this.isProcessing
      }
    },
    child_passphrase: function(value) {
      try {
        let decrypted = CryptoJS.AES.decrypt(
          sessionStorage.getItem('private_key'),
          value
        )

        if (
          decrypted.toString(CryptoJS.enc.Utf8) === '' ||
          decrypted.toString(CryptoJS.enc.Utf8).length === 0
        )
          return alert('Invalid passphrase')

        this.passphrase = value
        this.isVisible = false
      } catch (error) {
        const { message } = error

        if (message === 'ciphertext is null')
          return console.log('Encrypted value is null')
      }
    },
    child_redirect: function(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style scoped>
.col-lg-12.root {
  padding: 20px 50px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 7px 23px #88888852;
  border-radius: 12px;
}

.product__title {
  margin: 20px 0 30px 0;
}

.product__details {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.product__header {
  padding-bottom: 5px;
  border-spacing: 2rem;
  border-bottom: 2px solid black;
}

.product__description {
  margin: 10px 0;
}
</style>
